import { LoadingDashed } from "react-huge-icons/outline";

const LoadingIndicator = () => {
    return (<LoadingDashed className='animate-spin' />);
}

export default LoadingIndicator;